function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import './select_multiple.scss';
import CustomHTMLElement from 'html-element';

var SelectMultiple = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(SelectMultiple, _CustomHTMLElement);

  var _super = _createSuper(SelectMultiple);

  function SelectMultiple() {
    _classCallCheck(this, SelectMultiple);

    return _super.apply(this, arguments);
  }

  _createClass(SelectMultiple, [{
    key: "_runSetup",
    value: function _runSetup() {
      var _this = this;

      _get(_getPrototypeOf(SelectMultiple.prototype), "_runSetup", this).call(this);

      this.placeholder = this.querySelector('.select-multiple__placeholder');
      this.template = this.querySelector('.select-multiple__option--template');
      this.template.remove();
      this.template.classList.remove('select-multiple__option--template');
      this.optionsElement = this.querySelector('.select-multiple__options');
      this.selectButton = this.querySelector('.select-multiple__add');
      this.selectElement = this.querySelector('select');
      this.selectElement.addEventListener('change', this.optionSelected.bind(this));
      this.selectedValues = [];
      this.querySelectorAll('.select-multiple__option').forEach(function (optionElement) {
        optionElement.hiddenField = optionElement.querySelector('input[type=hidden]');
        var val = optionElement.hiddenField.value;

        _this.selectedValues.push(val);

        optionElement.closeIcon = optionElement.querySelector('sprite-svg');
        optionElement.closeIcon.addEventListener('click', function (_event) {
          optionElement.remove();

          _this.selectedValues.splice(_this.selectedValues.indexOf(val), 1);

          if (_this.selectedValues.length === 0) {
            _this.placeholder.style.display = '';
          }
        });
        _this.placeholder.style.display = 'none';
      });
    }
  }, {
    key: "optionSelected",
    value: function optionSelected(_event) {
      var _this2 = this;

      var value = this.selectElement.selectedOptions[0];

      if (value === undefined) {
        return;
      }

      var text = value.getAttribute('name') || value.innerText;
      var icon = value.getAttribute('icon');
      var val = value.getAttribute('value');

      if (this.selectedValues.includes(val)) {
        return;
      }

      this.selectedValues.push(val);
      var optionElement = this.template.cloneNode(true);
      optionElement.hiddenField = optionElement.querySelector('input[type=hidden]');
      optionElement.hiddenField.value = val;
      optionElement.textElement = optionElement.querySelector('span');
      optionElement.textElement.innerText = text;
      optionElement.closeIcon = optionElement.querySelector('sprite-svg');
      optionElement.closeIcon.addEventListener('click', function (_event) {
        optionElement.remove();

        _this2.selectedValues.splice(_this2.selectedValues.indexOf(val), 1);

        if (_this2.selectedValues.length === 0) {
          _this2.placeholder.style.display = '';
        }
      });
      this.optionsElement.append(optionElement);
      this.selectElement.value = '';
      this.placeholder.style.display = 'none';
    } ////////// Change State

  }, {
    key: "disable",
    value: function disable() {
      this.disabled = true;
      this.selectElement.disabled = true;
      this.setAttribute('disabled', '');
    }
  }, {
    key: "enable",
    value: function enable() {
      this.disabled = false;
      this.selectElement.disabled = false;
      this.removeAttribute('disabled', '');
    }
  }]);

  return SelectMultiple;
}(CustomHTMLElement);

export { SelectMultiple as default };
window.customElements.define('select-multiple', SelectMultiple);